package de.connect2x.timmy.i18n
import de.connect2x.tim.compose.i18n.I18nTIMView
import de.connect2x.trixnity.messenger.MatrixMessengerSettingsHolder
import de.connect2x.trixnity.messenger.i18n.DefaultLanguages.DE
import de.connect2x.trixnity.messenger.i18n.DefaultLanguages.EN
import de.connect2x.trixnity.messenger.i18n.GetSystemLang
import de.connect2x.trixnity.messenger.i18n.Languages
import kotlinx.datetime.TimeZone


class I18nTimViewWcImpl (
                   lang: Languages,
                   messengerSettings: MatrixMessengerSettingsHolder,
                   getSystemLang: GetSystemLang,
                   timeZone: TimeZone,
) : I18nTIMView(lang, messengerSettings, getSystemLang, timeZone) {

    override fun inactiveRoomsArchive() = translate {
        EN - "Accept leaving this chat or group"
        DE - "Chat oder Gruppe verlassen"
    }
}
